import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Paper, Typography } from '@mui/material';
import Component from '../../components/Component';

function GameDashboard() {
  return (
    <div>
      <Component>
        <div className="page-body">
          <div className="container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-6">
                  <h3>Game Dashboard</h3>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <Container maxWidth="lg" sx={{ marginTop: '10px' }}>
                      <Grid container spacing={3}>
                        <Grid item xs={4}>
                          <Link to="/admin/arcade/game-catalog" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0E6655', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Game catalog
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Hub tiles &amp; features by app version
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/competitions" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#1A5276', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Competition settings
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Prediction, FanWars, Mind Cricket per CID
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/fanwars-lineup" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#C0392B', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/player.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                FanWars Lineup
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/prediction-questions" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#16A085', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Prediction Questions
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/prediction-candidates" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#8E44AD', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Prediction Candidates
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/participation-force-active" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#D35400', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Extend Participation
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Force active after delayed kickoff
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/super-over-daily" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#2471A3', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Super Over Daily
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Schedule Today&apos;s Challenges (IST)
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/super-over-promotions" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#117A65', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Super Over Promotions
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Entry + win/tie rewards &amp; browse copy
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/pitch-word" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0B5345', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Pitch Word
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Review and fix the daily word
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/fan-scan" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#1D4ED8', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Fan Scan
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Quiz results and the questions players see
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>

                        <Grid item xs={4}>
                          <Link to="/admin/arcade/mind-cricket-league" style={{ textDecoration: 'none' }}>
                            <Paper
                              elevation={3}
                              sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#6C3483', color: '#FFFFFF' }}
                            >
                              <img className="player-icon" src="images/dashboard.png" alt="" />
                              <Typography variant="h5" gutterBottom>
                                Super Over League
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Mind Cricket analytics &amp; league controls
                              </Typography>
                            </Paper>
                          </Link>
                        </Grid>
                      </Grid>
                    </Container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Component>
    </div>
  );
}

export default GameDashboard;
